import {
	BaseState,
	DelegationActions,
	IGetLoginParametersRequest,
	IOAuthLoginRequest,
	LoginActions
} from '@bimser/common';
import { connect } from 'react-redux';
import Router from './Router';
import IRouterCProps from './entities/IRouterCProps';
import IRouterProps from './entities/IRouterProps';

const mapStateToProps = function (state: BaseState, props: IRouterProps): IRouterProps {
	return {
		isAuthenticated: state.user.token ? true : false,
		checkAuthenticationFinished: state.user.chekAuthenticationFinished
	};
};

const mapDispatchToProps = function (dispatch: Function): IRouterCProps {
	return {
		getLoginParameters: function (data: IGetLoginParametersRequest) {
			dispatch(LoginActions.loginParametersTransactionAction(data));
		},
		controlToken: function () {
			dispatch(LoginActions.controlTokenTransactionAction());
		},
		setDelegateInformation: function (data: any) {
			dispatch(DelegationActions.setDelegationInformationAction(data));
		},
		onOAuthLogin: function (data: IOAuthLoginRequest) {
			dispatch(LoginActions.onOAuthLoginTransaction(data));
		},
		onSSOControl: function () {
			dispatch(LoginActions.onSSOControlAction());
		}
	};
};

const RouterContainer = connect(mapStateToProps, mapDispatchToProps)(Router);
export default RouterContainer;
